import { useMutation } from "@tanstack/react-query";
import {
	putClientIdentificationDocumentsIdV2,
	type UpdateIdentificationDocumentRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type UpdateIdentificationDocumentVariables = {
	id: number;
	data: UpdateIdentificationDocumentRequestDTO;
};

export const useUpdateIdentificationDocumentMutation = () =>
	useMutation({
		mutationFn: processResponse(
			({ id, data }: UpdateIdentificationDocumentVariables) =>
				putClientIdentificationDocumentsIdV2(data, id),
		),
	});
